import { styled } from '@mui/material';
import { ReactComponent as Logo } from 'images/av-logo-vertical.svg';

export const FTDDRLogo = styled(Logo)(({ sx = {} }) => ({
  width: '250px',
  height: '66px',
  ...sx,
}));
